module.exports = __webpack_public_path__ + "img/huawei4.bf1d7989.png";